import { render, staticRenderFns } from "./ResolutionEquations.vue?vue&type=template&id=4bc61661&"
import script from "./ResolutionEquations.vue?vue&type=script&lang=js&"
export * from "./ResolutionEquations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports